<template>
    <div>
      <div v-if="rechargeLocUrl">
        <a type="primary" class="el-button buy-btn el-button--primary" target="_blank" :href="rechargeLocUrl" @click="rechargeSubmit">{{ $t('payNow') }}</a>
      </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                directRechargeUrl: '',
                showLoading: false,
                isChannelDirect: false,
            }
        },
        props: ['rechargeLocUrl', 'showLoading'],
        methods: {
            rechargeSubmit() {
                $('.el-icon-close').trigger('click');
            },
            cleanPage(){
                $('.method-container').css('display', 'none');
                $('.currency-select').css('display', 'none');
            }
        },
        updated(){
            this.cleanPage();
        }
    }
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
    @import "../../assets/scss/lib";

    .iframe {
        width: 100%;
        min-height: 400px;
        max-height: 600px;
    }
    .buy-btn {
        width: 250px;
        height: 45px;
        font-size: 18px;
        display: block;
        margin: 20px auto;
    }
</style>



// WEBPACK FOOTER //
// RechargeByLoc.vue?498687ab